import { useQuery } from '@tanstack/react-query';
import { getUniform } from '@/api/student';
import { Card } from '@/components/ui/Card';
import { PageHeader, QueryState } from '@/components/kit/ui';
import { unwrap } from '@/components/kit/data';
import { NotInClass } from '../shared';

interface Day { weekday: number; day: string; name: string; description: string | null; photo_path: string | null; today: boolean }

export function UniformPage() {
  const q = useQuery({ queryKey: ['student-uniform'], queryFn: () => getUniform().then((r) => unwrap<{ today: Day | null; week: Day[] }>(r)), retry: false });
  const week = q.data?.week ?? [];
  return (
    <div className="space-y-4">
      <PageHeader title="Uniform" subtitle="What to wear each school day." />
      <NotInClass error={q.error}>
        <QueryState q={q} isEmpty={!week.length} empty="The school has not set a uniform schedule yet.">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {week.map((d) => (
              <Card key={d.weekday} title={`${d.day}${d.today ? ' (today)' : ''}`}>
                {d.photo_path && <img src={d.photo_path} alt={d.name} className="w-full h-40 object-cover rounded-lg mb-2" />}
                <p className="font-medium">{d.name}</p>
                {d.description && <p className="text-sm text-slate-500 mt-1">{d.description}</p>}
              </Card>
            ))}
          </div>
        </QueryState>
      </NotInClass>
    </div>
  );
}
